
__webpack_require__.remotesLoadingData = { chunkMapping: {"616":["1047"]}, moduleIdToRemoteDataMapping: {"1047":{"shareScope":"default","name":"./ConfiguratorSaveWidget","externalModuleId":3079,"remoteName":"frontend_basket"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
